import * as Api from "@api";
import { IXLMouthpiece } from "./types";

const AllXLMouthpieces: (IXLMouthpiece & { comingSoon: boolean })[] = [
    {
        comingSoon: false,
        slug: "white-snaptix",
        title: "White Plastic Snaptix",
    },
    {
        comingSoon: false,
        slug: "black-snaptix",
        title: "Black Plastic Snaptix",
    },
    {
        comingSoon: false,
        slug: "ceramic-barrel-white",
        title: "Ceramic Barrel White"
    },
    {
        comingSoon: false,
        slug: "plastic-barrel-black",
        title: "Plastic Barrel Black",
    },
    {
        comingSoon: false,
        slug: "plastic-barrel-white",
        title: "Plastic Barrel White",
    },
    {
        comingSoon: false,
        slug: "plastic-barrel-clear",
        title: "Plastic Barrel Clear*",
    },
    {
        comingSoon: true,
        slug: "plastic-duckbill-white",
        title: "Plastic Duckbill White*",
    },
    {
        comingSoon: true,
        slug: "plastic-duckbill-black",
        title: "Plastic Duckbill Black*",
    },
    {
        comingSoon: true,
        slug: "plastic-ellipse-black",
        title: "Plastic Ellipse Black*",
    },
    {
        comingSoon: true,
        slug: "plastic-ellipse-white",
        title: "Plastic Ellipse White*",
    },
    {
        comingSoon: true,
        slug: "plastic-bottle-top-white",
        title: "Plastic Bottle Top White*",
    },
    {
        comingSoon: true,
        slug: "plastic-bottle-top-black",
        title: "Plastic Bottle Top Black",
    },
];

export const XLMouthpieces = AllXLMouthpieces.filter(({ slug }) => !(Api.SnaptixHidden && slug.endsWith("-snaptix")));

export const thumbnailsDirectory = "/images/products/@global/xl-mouthpieces/";

export const ProductXLMouthpiecesContentKeys = [
    "mouthpieces.comingSoon",
    "mouthpieces.patent",
    "mouthpieces.plastic-duckbill-black.patent",
    "mouthpieces.plastic-duckbill-white.patent",
] as const satisfies Api.ContentKey[];

export const ProductXLMouthpiecesSectionContentKeys = [
    "mouthpieces.headline",
    "mouthpieces.body",
    // Footnote under the grid explaining the "*" suffix on custom-only mouthpiece titles.
    // Optional: products that have not been seeded with it simply render no footnote.
    ["mouthpieces.footer"],
    ...ProductXLMouthpiecesContentKeys,
] as const satisfies Api.ContentKey[];